export const projectActionType = {
  SET_DATA: "SET_DATA",
  CHANGE_CATAGORY: "CHANGE_CATAGORY",
  LOAD_NEXT_DATASET: "LOAD_NEXT_DATASET",
  LOAD_PREVIOUS_DATASET: "LOAD_PREVIOUS_DATASET",
  REMOVE_PROJECT_FROM_STATE: "REMOVE_PROJECT_FROM_STATE",
};
